<ppl-accordion [title]="'Additional Attribute'" [isOpen]="true"
  *authorize="[pageId, tabId, 'AdditionalAttributes', 'section']">
  @switch (mode) {
    @case ('read') {
      <div class="ant-row" style="justify-content: center;">
        <div class="ant-col-24">
          <ppl-list-table [disableSort]="true" [disableSearch]="true"
            [enableActions]="isSectionEditable || isSectionDeletable" [actionButtons]="actionButtons"
            (gridAction)="action($event)" [data]="gridData" [disableSelection]="true" [cols]="cols" [gridTitle]="false"
            [pagination]="false" [from]="'additional_attributes'"></ppl-list-table>
        </div>
      </div>
      <div class="ant-row" style="justify-content: center;">
        @if(isSectionEditable) {

        <div class="ant-col-6" style="padding-top: 4px;">
          <ppl-dropdown-select id="selectedAttribute" placeholder="Select attribute to be added"
            [(ngModel)]="selectedAttributeType" (selectionChange)="validateSelectedAttribute($event)" [options]="options"
            [optionLabel]="'attribute_text'" [optionValue]="'id'" optionDisabled="disabled" required="true"
            aria-required="true" [attr.aria-label]="'Select Attribute'" style="width: 100%; margin-bottom: 16px">
          </ppl-dropdown-select>

          @if (displayTypeError) {
          <div class="pl-1 error-message">Attribute type is required</div>
          }
        </div>
        }

        @if(selectedAttributeType){
          <div class="ant-col-4" style="padding-top: 4px; padding-left: 10px;">
            @if(fieldType === 'dropdown'){
              <ppl-dropdown-select id="selectedAttribute" placeholder="Select" [(ngModel)]="attributeValue"
                [options]="lookupData[selectedAttribute] || []" [optionLabel]="'value'" [optionValue]="'value'"
                optionDisabled="disabled" required="true" aria-required="true" [attr.aria-label]="'Type'"
                style="width: 100%; margin-bottom: 16px">
              </ppl-dropdown-select>
            }
            @else if(dataType === 'text'){
              <input nz-tooltip nzTooltipPlacement="topRight" nz-input id="attributeValue" [(ngModel)]="attributeValue"
                (ngModelChange)="validateAttributeValue($event)" required="true" placeholder="Field Value" />

              @if(displayValueError) {
                <div class="pl-1 error-message">Attribute value is required</div>
              }
            }@else {
              <!-- <nz-date-picker [(ngModel)]="attributeValue" id="attributeValue" [nzFormat]="'MM/dd/yyyy'" [nzDisabledDate]="disabledDate"></nz-date-picker> -->
              <ppl-date-picker [(ngModel)]="attributeValue" id="attributeValue" [placeholder]="'Select date'"
                dateFormat="mm/dd/yy" [yearRange]="'1900:2050'" [iconDisplay]="'input'" inputId="icondisplay"
                [panelStyleClass]="'custom-calendar-panel'" [maxDate]="maxDateForCalendar">
              </ppl-date-picker>
            }
            @if(displayValueError) {
              <div class="pl-1 error-message">Attribute value is required</div>
            }
          </div>

          @if(displayDates) {
            <div class="ant-col-3" style="padding-top: 4px; padding-left: 10px;">
              <ppl-date-picker [(ngModel)]="startDate" id="startDate" [placeholder]="'Effective From Date'" dateFormat="mm/dd/yy"
                [yearRange]="'1900:2050'" [iconDisplay]="'input'" inputId="icondisplay"
                [panelStyleClass]="'custom-calendar-panel'">
              </ppl-date-picker>
              <!-- <nz-date-picker [(ngModel)]="startDate" id="startDate" [nzFormat]="'MM/dd/yyyy'"></nz-date-picker> -->

              @if(displayStartDateError) {
                <div class="pl-1 error-message">Effective From Date is required</div>
              }
            </div>
            <div class="ant-col-3" style="padding-top: 4px; padding-left: 10px;">
              <!-- <nz-date-picker [(ngModel)]="endDate" id="endDate" [nzFormat]="'MM/dd/yyyy'"></nz-date-picker> -->
              <ppl-date-picker [(ngModel)]="endDate" id="endDate" [placeholder]="'Effective To Date'" dateFormat="mm/dd/yy"
                [yearRange]="'1900:2050'" [iconDisplay]="'input'" inputId="icondisplay"
                [panelStyleClass]="'custom-calendar-panel'">
              </ppl-date-picker>
              @if(displayEndDateError) {
                <div class="pl-1 error-message">Effective To Date is required</div>
              }
            </div>
          }
        }

        @if(isSectionEditable) {
        <div class="ant-col-2" style="padding-left: 20px;">
          <ppl-button label="Add" [ariaLabel]="'Add New Attribute'" icon="fa fa-plus" [customClass]="'ghost-button'"
            [iconPosition]="'left'" (click)="addAttributes()"></ppl-button>
        </div>
        }
      </div>
    }

    @case('edit'){
      <div class="ant-row" style="justify-content: center;">
        <div class="ant-col-6" style="padding-top: 4px;">
          <input nz-tooltip nzTooltipPlacement="topRight" nz-input id="selectedAttribute"
            [(ngModel)]="selectedAttributeType" [disabled]="true" placeholder="Selected Attribute" />
        </div>
        <div class="ant-col-4" style="padding-top: 4px; padding-left: 10px;">
          @if(fieldType === 'dropdown'){
          <ppl-dropdown-select id="selectedAttribute" [(ngModel)]="attributeValue"
            [options]="lookupData[selectedAttribute] || []" [optionLabel]="'value'" [optionValue]="'value'"
            placeholder="Select" required="true" aria-required="true" [attr.aria-label]="'Type'"
            style="width: 100%; margin-bottom: 16px">
          </ppl-dropdown-select>

          }
          @else if(dataType === 'text'){

          <input nz-tooltip nzTooltipPlacement="topRight" nz-input id="attributeValue" [(ngModel)]="attributeValue"
            (ngModelChange)="validateAttributeValue($event)" required="true" placeholder="Field Value" />

          @if(displayValueError) {
          <div class="pl-1 error-message">Attribute value is required</div>
          }
          }@else {
          <ppl-date-picker [(ngModel)]="attributeValue" id="attributeValue" [placeholder]="'Select date'"
            dateFormat="mm/dd/yy" [yearRange]="'1900:2050'" [iconDisplay]="'input'" inputId="icondisplay"
            [panelStyleClass]="'custom-calendar-panel'">
          </ppl-date-picker>
          <!-- <nz-date-picker [(ngModel)]="attributeValue" id="attributeValue" [nzFormat]="'MM/dd/yyyy'"></nz-date-picker> -->
          }
          @if(displayValueError) {
          <div class="pl-1 error-message">Attribute value is required</div>
          }
        </div>

        @if(displayDates) {
        <div class="ant-col-3" style="padding-top: 4px; padding-left: 10px;">
          <ppl-date-picker [(ngModel)]="startDate" id="startDate" [placeholder]="'Select date'" dateFormat="mm/dd/yy"
            [yearRange]="'1900:2050'" [iconDisplay]="'input'" inputId="icondisplay"
            [panelStyleClass]="'custom-calendar-panel'">
          </ppl-date-picker>
          <!-- <nz-date-picker [(ngModel)]="startDate" id="startDate" [nzFormat]="'MM/dd/yyyy'"></nz-date-picker> -->

          @if(displayStartDateError) {
          <div class="pl-1 error-message">Start date is required</div>
          }

        </div>
        <div class="ant-col-3" style="padding-top: 4px; padding-left: 10px;">
          <ppl-date-picker [(ngModel)]="endDate" id="endDate" [placeholder]="'Select date'" dateFormat="mm/dd/yy"
            [yearRange]="'1900:2050'" [iconDisplay]="'input'" inputId="icondisplay"
            [panelStyleClass]="'custom-calendar-panel'">
          </ppl-date-picker>
          <!-- <nz-date-picker [(ngModel)]="endDate" id="endDate" [nzFormat]="'MM/dd/yyyy'"></nz-date-picker> -->
          @if(displayEndDateError) {
          <div class="pl-1 error-message">End date is required</div>
          }
        </div>
        }
      </div>

      <div class="custom-row">
        <ppl-button label="Cancel" icon="fa fa-ban" [customClass]="'alt-button'" [iconPosition]="'left'"
          (click)="cancelEdit()"></ppl-button>

        <ppl-button label="Save" icon="fa fa-floppy-o" [customClass]="'alt-button'" [iconPosition]="'left'"
          (click)="save()"></ppl-button>
      </div>
    }
  }

</ppl-accordion>


<ppl-popup-dialog [(isVisible)]="showConfirmationDialog" [title]="'Delete Attribute'" [isOkText]="'Delete'"
  (cancel)="onClose()" [showButtons]="true" [position]="'top'" size="medium" (confirm)="handleConfirmDelete()">
  <div>
    <h3 class="ppl-gray-text mb-4">
      Are you sure you wish to delete?
    </h3>
    <p>
      This action cannot be undone. </p>
  </div>
</ppl-popup-dialog>